module.exports = __webpack_public_path__ + "ea7e3de7e73f1e2d40ff69019e3c30f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ranks/school-comp-medal-3-basic.png
// module id = 2929
// module chunks = 0